<template>
<div class="drawerWrap">
  <div class="drawerBody">
    <el-form ref="form" :model="form" :rules="formRules" label-position="right" label-width="140px">
      <el-form-item label="设备类型名称" prop="name">
        <el-input v-model="form.name" minlength="1" maxlength="20" placeholder="请输入设备名称"></el-input>
      </el-form-item>
      <el-form-item label="设备注册至" prop="registTo">
        <el-select v-model="form.registTo" placeholder="请选择设备注册至">
           <!-- :disabled="handleType === 'edit'" -->
          <el-option v-for="item in deviceList" :key="item.val" :label="item.label" :value="item.val"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设备心跳周期" prop="heartBeat">
        <el-input v-model="form.heartBeat" minlength="1" maxlength="20" placeholder="请输入设备心跳周期"></el-input><span> S</span>
      </el-form-item>
      <el-form-item label="设备报警时间间隔" prop="alarmInterval">
        <el-input v-model="form.alarmInterval" minlength="1" maxlength="20" placeholder="请输入设备报警时间间隔"></el-input><span> S</span>
      </el-form-item>
      <el-form-item label="通信协议方式" prop="protocol">
        <el-select v-model="form.protocol" placeholder="请选择通信协议方式">
          <el-option v-for="item in zoneList" :key="item.val" :label="item.label" :value="item.val"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否启用" prop="isEnabled">
        <el-select v-model="form.isEnabled" clearable placeholder="请选择启用方式">
          <el-option v-for="item in isEnabledData" :key="item.val" :label="item.label" :value="item.val"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="上传文件:">
        <el-upload drag :limit='limitNum' :auto-upload="false" :action="UploadUrl()" :before-upload="beforeUploadFile" :on-change="fileChange" :on-exceed="exceedFile" :on-success="handleSuccess" :on-error="handleError" :on-remove="handleRemove" :file-list="fileList">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传xlsx/xls文件，且不超过10M</div>
        </el-upload>
      </el-form-item>
    </el-form>
  </div>
  <div class="drawerFoot">
    <el-button type="primary" @click="confirmHandle()" :loading="loading">{{ loading ? '提交中' : '提交' }}</el-button>
    <el-button @click="cancelHandle()">取 消</el-button>
  </div>
</div>
</template>

<script>
export default {
  props: {
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    handleType: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      limitNum: 1, // 上传excell时，同时允许上传的最大数
      fileList: [], // excel文件列表
      formData:{},
      left: "left",
      show: "添加",
      // loading: false,
      isEnabledData: [
        {
          val: true,
          label: '启用'
        },
        {
          val:false,
          label: '禁用'
        }
      ],
      zoneList: [
        {
          label:'TCP',
          val:1
        },
        {
          label:'UDP',
          val:2
        }
      ],
      deviceList: [
         {
          label:'XY',
          val:0
        },
        {
          label:'LT',
          val:1
        }
      ],
      form: {
        name: '',
        registTo: '',
        protocol:'',
        heartBeat:'',
        alarmInterval:'',
        isEnabled: '',
      },
      formRules: {
        name: [
          {
            required: true,
            validator: this.validateDeviceName,
            trigger: "blur"
          }
        ],
        // heartBeat: [{
        //   required: true,
        //   validator: this.validateDeviceCode,
        //   trigger: "blur"
        // }],
        // alarmInterval: [{
        //   required: true,
        //   validator: this.validateLocation,
        //   trigger: "blur"
        // }],
        registTo:[{
         required: true,
          message: "请选择设备注册到",
          trigger: ["change"] 
        }],
        protocol:[{
          required: true,
          message: "请选择通信协议方式",
          trigger: ["change"] 
        }],
        isEnabled:[{
          required: true,
          message: "请选择启用方式",
          trigger: ["change"] 
        }]
      },
    }
  },
  created() {
    console.log(this.handleType)
    console.log(this.editData)
    // console.log(this.baseUrlAddr)
  },
  mounted() {
    this.init();
  },
  inject:['pinit','pinitdata'],
  methods: {
    init() {
      if (this.handleType == 'add') {
        this.form= {
          name: '',
          registTo: '',
          protocol:'',
          heartBeat:'',
          alarmInterval:'',
          isEnabled: '',
        }
      } else if (this.handleType == 'edit') {
        console.log(this.editData)
        if (this.editData.id) {
          this.form = {
            name: this.editData.name,
            registTo: this.editData.registTo,
            heartBeat: this.editData.heartBeat,
            alarmInterval: this.editData.alarmInterval,            
            protocol: this.editData.protocol,
            isEnabled: this.editData.isEnabled,
          }
          console.log(this.form);

        }
      }
    },
    cancelHandle() { //取消
      this.$emit("cancel", false);
    },
    confirmHandle() {
      //确认
      let formDates = {
        name: this.form.name,
        registTo: this.form.registTo,
        heartBeat: this.form.heartBeat,
        alarmInterval: this.form.alarmInterval,
        protocol: this.form.protocol,
        isEnabled:this.form.isEnabled
      };
      console.log(formDates);
      this.$refs["form"].validate(valid => {
        if (!valid) {
          return this.msg.error("请按要求完善表单信息");
        }
        this.$emit("update:loading", true);
         var formData = new FormData()
          console.log(this.fileList[0])
          formData.append('file', this.fileList[0])
        if (this.handleType == 'add') {
          this.request.postParamsForm("/front/device/type/add", formDates,formData).then(res => {
            this.$emit("update:loading", false);
            console.log(res);
            if (res.code == 200) {
              this.msg.success('设备类型添加成功');
              this.$emit('confirm', res.code);
              this.pinit();
              this.pinitdata();
            } else if (res.code == 500) {
              this.msg.warn(res.msg);
            }
          });
        } else if (this.handleType == 'edit') {
          let source = {
            id: this.editData.id,
            // termid: this.getEditData.termid
          }
          let editDatas = Object.assign(formDates, source);
          console.log(editDatas)
          this.request.postParamsForm("/front/device/type/update", editDatas,formData).then(res => {
            console.log(res);
            this.$emit("update:loading", false);
            if (res.code == 200) {
              this.msg.success('设备类型编辑成功')
              this.$emit('confirm', res.code)
            } else if (res.code == 500) {
              this.msg.warn(res.msg);
            }
          });
        }
        // this.$emit("confirm", this.form);
        //   this.storage.setSession("headImg", this.form.img);
      });
    },
    // 文件超出个数限制时的钩子
    exceedFile(files, fileList) {
      this.$message.warning(
        // `只能上传 ${this.limitNum} 个文件，当前共选择了 ${files.length + fileList.length} 个`
        `只能上传 ${this.limitNum} 个文件`
      );
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {
      //      console.log(file,fileList);
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      //    console.log(extension);

      if (extension !== 'xls' && extension !== 'xlsx') {
        this.fileList.shift();
        return this.$message.warning('上传模板只能是 xls、xlsx格式!')
      }
      let size = file.size / 1024 / 1024;
      if (size > 10) {
        this.fileList.shift();
        return this.$message.warning("文件大小不得超过10M");
      }
      this.fileList.push(file.raw)
      // console.log(this.fileList);
    },
    // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
    beforeUploadFile(file) {
      //   console.log('before upload');
      console.log(file);
      // const extension = file.name.split('.')[1] === 'xls'
      // const extension2 = file.name.split('.')[1] === 'xlsx'
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (extension !== 'xls' && extension !== 'xlsx') {
        this.$message.warning('上传模板只能是 xls、xlsx格式!')
      }
      let size = file.size / 1024 / 1024;
      if (size > 10) {
        this.$message.warning("文件大小不得超过10M");
      }
    },
    // 文件上传成功时的钩子
    handleSuccess(res, file, fileList) {
      this.$message.success("文件上传成功");
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      //   console.log(file, fileList);
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$message.error("文件上传失败");
    },
    UploadUrl: function () {
      // 因为action参数是必填项，我们使用二次确认进行文件上传时，直接填上传文件的url会因为没有参数导致api报404，所以这里将action设置为一个返回为空的方法就行，避免抛错
      return "";
    },
    uploadFile() {
      if (this.fileList.length === 0) {
        this.$message.warning("请上传文件");
      } else {
        let formData = new FormData();
        //  console.log(this.fileList)
        for (const key in this.fileList[0]) {
          formData.append(key, this.fileList[0][key]);
        }
        // formData.append('file', this.fileList);
        //  console.log(formData)
        this.formData = formData;
        //  console.log(this.formData)
      }
    },
    validateDeviceName(rule, value, callback) {
      if (value === ""||value === null) {
        callback(new Error("设备类型名称不能为空"));
      } else if (value.length > 32) {
        callback(new Error("设备类型名称长度不能超过32个字符"));
      } else if (value.length < 2) {
        callback(new Error("设备类型名称长度不能少于2个字符"));
      } else {
        var reg = new RegExp(/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/);
        if (!reg.test(value)) {
          callback(
            new Error("设备类型名称不合法,请输入由_或字母或汉字或数字组成！")
          );
        } else {
          callback();
        }
      }
    },
    // validateDeviceCode(rule, value, callback) {
    //   if (value === ""||value === null) {
    //     callback(new Error("编码不能为空"));
    //   } else if (value.length > 12) {
    //     callback(new Error("编码长度必须为12个字符"));
    //   } else if (value.length < 12) {
    //     callback(new Error("编码长度必须为12个字符"));
    //   } else {
    //     var reg = new RegExp(/^[0-9a-zA-Z]*$/);
    //     if (!reg.test(value)) {
    //       callback(new Error("编码不合法,请输入由英文(a-z/A-Z)或数字组成的编码！"));
    //     } else {
    //       callback();
    //     }
    //   }
    // },
    // validateLocation(rule, value, callback) {
    //   if (value === ""||value === null) {
    //     callback(new Error("安装位置不能为空"));
    //   } else if (value.length > 20) {
    //     callback(new Error("安装位置长度不能超过20个字符"));
    //   } else if (value.length < 1) {
    //     callback(new Error("安装位置长度不能少于1个字符"));
    //   } else {
    //     var reg = new RegExp(/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/);
    //     if (!reg.test(value)) {
    //       callback(
    //         new Error("安装位置不合法,请输入由_或字母或汉字或数字组成！")
    //       );
    //     } else {
    //       callback();
    //     }
    //   }
    // },
  }
};
</script>

<style lang="scss">
.drawerWrap {
  .el-transfer {
    .el-transfer-panel {
      text-align: left;
      width: 250px;
    }

    .el-transfer__buttons {
      width: 65px;
      text-align: center;

      .el-button {
        margin: 5px 0;
        width: 56px;
      }
    }
  }

  .el-switch {
    width: 100%;
  }

  .el-image {
    margin-right: 20px;
  }

  .el-form {
    margin-top: 20px;

    .el-form-item__label {
      line-height: 50px;
    }

    .el-form-item__content {
      line-height: 50px;
      .el-upload{
        width: 270px;
        .el-upload-dragger{
          width: 100%;
        }
      }
      .el-upload__tip{
        line-height: 20px;
      }
    }

    .el-select {
      width: 100%;
    }

    .el-textarea {
      width: 270px;

      .el-textarea__inner {
        height: 100px !important;
        line-height: 20px;
        color: #6e6e6e;
        font-size: 14px;
      }
    }

    .el-input {
      width: 270px;

      .el-input__inner {
        height: 40px;
        line-height: 40px;
      }
    }
  }

  .drawerBody .el-form-item__label,
  .sp {
    color: #6e6e6e;
  }

}
</style>
